import make, { Enum } from '@xaamin/enum';

class CancelacionStatus extends Enum {

  name = 'CancelacionStatus';

  enum = {
    'received': 0,
    'processing': 10,
    'cancelled': 1,
    'rejected': -1,
    'disallowed': 2,
    'error': 3,
    'dead': 4,
    'done': 9,
    'undefined': 33,
  }

}

export default make(CancelacionStatus);